<script lang="ts">
	interface Props {
		year?: number;
		companyName?: string;
		classes?: string;
	}

	let {
		year = new Date().getFullYear(),
		companyName = 'Supertip.gg',
		classes = 'text-sm text-surface-800-200 font-rethink'
	}: Props = $props();
</script>

<div class="flex flex-col items-center {classes}">
	<div>© {year} {companyName}. All rights reserved.</div>
</div>
